export const newsletterSignup = {
  type: 'newsletter-signup',
  name: 'Newsletter Signup',
  icon: 'fas fa-envelope',
  settings: {},
  formSchema: {
    properties: {
      name: {
        type: 'string',
        showInForm: true,
        formFieldType: 'text'
      },
      embed: {
        label: 'Embed',
        type: 'string',
        showInForm: true,
        formFieldType: 'select',
        options: [
          ['true', 'In body'],
          ['repeat', 'In text']
        ]
      },
      toastCaption: {
        label: 'Toast Caption',
        type: 'string',
        showInForm: true,
        formFieldType: 'text'
      },
      salesForceCampaignId: {
        label: 'Custom Salesforce Campaign ID',
        type: ['string', 'null'],
        showInForm: true,
        formFieldType: 'text'
      },
      buttonText: {
        label: 'Button text',
        type: ['string', 'null'],
        showInForm: true,
        formFieldType: 'text'
      },
      buttonTitle: {
        label: 'Button title (if mode = popup) / Subtitle (otherwise)',
        type: 'string',
        showInForm: true,
        formFieldType: 'text'
      },
      title: {
        label: 'Title',
        type: 'string',
        showInForm: true,
        formFieldType: 'text'
      },
      insertionType: {
        label: 'Insertion type',
        type: 'string',
        showInForm: true,
        formFieldType: 'select',
        options: [
          ['element', 'Element'],
          ['textblock', 'Text block']
        ],
        selected: 'element'
      },
      startingPoint: {
        type: 'number',
        showInForm: true,
        formFieldType: 'number',
        label: 'Starting point'
      },
      repeatEvery: {
        type: 'number',
        showInForm: true,
        formFieldType: 'number',
        label: 'Repeat every'
      },
      maxRepetitions: {
        type: 'number',
        showInForm: true,
        formFieldType: 'number',
        label: 'Max repetitions',
        default: false
      }
    },
    required: ['name', 'buttonTitle', 'buttonType', 'title']
  },
  allowChildren: true,
  color: 'green',
  group: 'ui'
};
